import React, { Component } from 'react';

class CountryListComponent extends Component { 

    handelSelection = (e) => {
        this.props.onSelCountry(e); 
    }      

    render(){

        const {arrCountryList, countryListClass, countrySelected} = this.props; 
        let countryFieldName = 'sel_country';   
        if(this.props.hasOwnProperty('countryFieldName') && this.props.countryFieldName.length > 0) countryFieldName = this.props.countryFieldName;  
        return(
            <React.Fragment>
                <select onChange={(e) => this.handelSelection(e)} name={countryFieldName} className={countryListClass.length >0 ? countryListClass : ''} value={countrySelected||''} >
                    <option value="0">Select</option>
                    {Array.isArray(arrCountryList) && arrCountryList.map((item) => <option key={item.id} value={item.id}>{item.nationality}</option>)} 
                </select>
            </React.Fragment>  
        )
    }

}

export default CountryListComponent;